import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from '@/app/store/hooks';
import { APPLICATION_ROLES } from '@/features/auth/store/availableRolesSlice';

/**
 * Route guard that restricts access to the Super Admin (owner) role only.
 * Any other role is redirected to the dashboard.
 */
export function OwnerOnlyRoute() {
  const user = useAppSelector((state) => state.user);
  const userRoleId = Number(user.data?.roleId);

  if (userRoleId !== APPLICATION_ROLES['Super Admin'].id) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
